import { render, staticRenderFns } from "./Landingpage.vue?vue&type=template&id=0c0b7593&scoped=true"
import script from "./Landingpage.vue?vue&type=script&lang=ts"
export * from "./Landingpage.vue?vue&type=script&lang=ts"
import style0 from "./Landingpage.vue?vue&type=style&index=0&id=0c0b7593&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0b7593",
  null
  
)

export default component.exports